<template>
  <div>
    <div class="tracking-code-step">
      <div class="text-left m-t-15">
        <div class="install-tracking-code">
          <div class="onboarding-panel-2">
            <pre>
              <code>{{ trackingCode }}</code>
              <div class="code-shader">
                <a @click="copiedSuccess" v-clipboard:copy="trackingCode"><img style="margin-right: 8px" src="@/assets/images/icons/Copy_icon.svg">Copy to clipboard</a>
              </div>
            </pre>
            <div class="copy-mobile">
              <a @click="copiedSuccess" v-clipboard:copy="trackingCode"><img style="margin-right: 8px" src="@/assets/images/icons/Copy_icon.svg">Copy to clipboard</a>
            </div>
            <button type="button" name="button" @click="goToBilling">Pasted, let's go</button>
            <a class="do-later" @click="goToBilling">I'll do it later</a>
          </div>
          <div class="row m-t-15" style="padding: 0 2rem;">
            <h5>Other installation options:</h5>
            <div class="row flex m-t-15 installation-options" style="justify-content: space-between">
              <div class="col-md-4 boxx" style="margin-right: 1rem">
                <div>
                  <h4>Google Tag Manager</h4>
                  <p>
                    <a :href="`${supportLink}/en/articles/101692-can-the-html-tracking-code-be-added-through-google-tag-manager`" target="_blank">Learn more</a>
                  </p>
                </div>
                <img src="@/assets/images/tagmanager.png" height="58" alt/>
              </div>
              <div class="col-md-4 boxx">
                <div>
                  <h4>Wordpress</h4>
                  <p>
                    <a :href="`${supportLink}/en/articles/4875086-installing-the-clickcease-tracking-code-on-a-wordpress-based-website`" target="_blank">
                      <span>Learn more</span>
                    </a>
                  </p>
                </div>
                <img src="@/assets/images/wp.png" height="58" alt />
              </div>
              <div class="col-md-4 boxx" style="margin-left: 1rem; flex-direction: column; align-items: flex-start; padding-top: 1rem; padding-bottom: 1rem; padding-left: 2rem; ">
                <h4>Email the instructions</h4>
                <div class="flex last-box" style="align-items: center; width: 100%;">
                  <input type="email" style="padding: 1em" v-model="devEmail" id="exampleInputEmail1" autofocus required placeholder="Email"/>
                  <button type="button" name="button" @click="emailDeveloper">Send</button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="tracking-code-step-mobile hide-in-desktop">
      <div style="margin: 0 auto;">
        <h3>Tracking code installation</h3>
        <h4>Receive the code along with instructions to easily finish setting up on your desktop</h4>
      </div>
      <div class="flex last-box" style="align-items: center; width: 100%;">
        <EmailCTA :btn-text="'Send'"/>
        <input type="email" style="padding: 1em" v-model="devEmail" id="exampleInputEmail2" autofocus required placeholder="Email"/>
        <button type="button" name="button" @click="emailDeveloper" v-html="'Send'"/>
      </div>
      <div style="margin: 0 auto;">
        <p>You can also find this code later in the dashboard</p>
      </div>
      <a class="do-later" @click="goToBilling">I'll do it later</a>
    </div>
  </div>
</template>

<script>
// import { DataLayerService } from "@/services/dataLayer";
import { statjsCode } from "@/consts/trackingCodes";
import EmailCTA from "@/components/landing/EmailCTA";
import { AppConfig } from "@/config";

export default {
  data() {
    return {
      trackingCode: statjsCode,
      devEmail: "",
      supportLink: AppConfig.supportUrl,
    }
  },
  components: {
    EmailCTA,
  },
  mounted() {
    // this.devEmail = _.get(this, 'data.userName')
    // this.SET_STEP(7);
    // const object = {
    //   event: 'onboarding',
    //   external_id: this.sessionStorSafe.getItem('entranceID'),
    //   email: this.$store.state.gData.userName,
    //   onboarding_step_number: 7,
    //   phone: _.get(this.$store, 'state.gData.phone'),
    //   name: _.get(this.$store, 'state.gData.fullName'),
    //   onboarding_step_name: 'code_install'
    // }
    // DataLayerService.sendEvent(object);
  },
  methods: {
    goToBilling() {
      console.log('enter to goToBilling')
    },

    emailDeveloper() {
      console.log('enter to emailDeveloper')
    },

    copiedSuccess() {
      console.log('enter to copiedSuccess')

    },
  }
}
</script>

<style lang="scss" scoped>
@import "src/assets/style/responsive";

.tracking-code-step-mobile {
  padding: 0 1.5rem;
  div {
    h3 {
      color: black;
      font: normal normal 900 28px/31px Sofia Pro !important;
      text-align: center;
    }
    h4 {
      color: black;
      font: normal normal 300 19px/21px Sofia Pro Light !important;
      text-align: center;
      margin-bottom: 40px;
    }
    p {
      color: #787878;
      font-family: "Sofia Pro Light";
      font: normal normal normal 14px/20px Sofia Pro Light !important;
      text-align: center;
      margin-bottom: 60px;
    }
  }
  .last-box {
    margin: 0 auto;
    margin-bottom: 19px;
    max-width: 375px;
    input {
      flex: 1;
      height: 45px;
      background: #FFFFFF 0% 0% no-repeat padding-box;
      border: 1px solid #E2E2E2;
      border-radius: 23px 0px 0px 23px;
      padding-left: 2em !important;
    }
    button {
      background: #F87708 0% 0% no-repeat padding-box;
      border: 2px solid #F87708;
      border-radius: 0px 23px 23px 0px;
      width: 88px;
      height: 45px;
      font: normal normal normal 16px/22px Sofia Pro;
      letter-spacing: 0px;
      color: #FFFFFF;
    }
  }
  .do-later {
    text-align: center;
    text-decoration: underline;
    font: normal normal 300 16px/22px Sofia Pro;
    letter-spacing: 0px;
    color: #787878;
    margin-top: 19px;
    display: flex;
    justify-content: center;
  }
}
.tracking-code-step {
  @media (max-width: 1024px) {
    display: none !important;
  }
  .do-later {
    text-align: center;
    text-decoration: underline;
    font: normal normal 300 16px/22px Sofia Pro;
    letter-spacing: 0px;
    color: #787878;
    margin-top: 19px;
    display: flex;
    justify-content: center;
  }
  .installation-options {
    font-family: "Sofia Pro" !important;
    @media (max-width: 1024px) {
      flex-direction: column;
      align-items: center;
      padding: 0 2rem;

      .boxx {
        width: 100%;
        margin: 10px 0;
        height: inherit;
      }
    }

  }
  h5 {
    font-family: "Sofia Pro" !important;
    @media (max-width: 1024px) {
      font: normal normal 900 24px/31px Sofia Pro !important;
      padding: 0 2em;
      text-align: center;
    }
  }
  .cover-wrapper {
    h3 {
      text-align: center;
      font: normal normal 900 40px/43px Sofia Pro !important;
      letter-spacing: 0px;
      color: #282421;
      @media (max-width: 1024px) {
        font: normal normal 900 28px/31px Sofia Pro !important;
      }
    }
    h4 {
      text-align: center;
      font: normal normal 300 20px/31px Sofia Pro !important;
      letter-spacing: 0px;
      color: #282421;
      max-width: 600px;
      margin: 0 auto;
      @include mobile {
        padding: 0 1rem;
        font: normal normal 300 16px/18px Sofia Pro !important;
      }
    }
  }
  .m-t-15 {
   margin-top: 15px !important;
  }
}
.install-tracking-code {
  h5 {
    text-align: left;
    font: normal normal 900 24px/37px Sofia Pro;
    letter-spacing: 0px;
    color: #282421;
  }
  .onboarding-panel-2 {
    max-width: 788px;
    margin: 0 auto;
    border-radius: 44px;
    border: 0;
    button {
      margin: 0 auto;
      margin-top: 53px;
      background: #F87708 0% 0% no-repeat padding-box;
      border-radius: 28px;
      border: 0;
      font: normal normal normal 18px/22px Sofia Pro;
      color: #FFFFFF;
      width: 189px;
      height: 58px;
      display: flex;
      justify-content: center;
      align-items: center;
      @media (max-width: 840px) {
        margin-top: 15px;
      }
    }
    pre {
      background: #FFF7F5 0% 0% no-repeat padding-box;
      border-radius: 44px;
      height: 162px;
      border: 0;
      overflow: hidden;
    }
    .copy-mobile {
      display: none;
      @media (max-width: 840px) {
        display: flex;
        width: 100%;
        a {
          margin: 0 auto;
          margin-top: 1rem;
          text-decoration: underline;
          font: normal normal normal 16px/22px Sofia Pro !important;
          letter-spacing: 0px;
          color: #F87708;
        }
      }
    }
    .code-shader {
      position: absolute;
      height: 180px;
      margin-left: -9.5px;
      margin-top: -226px;
      width: 788px;
      max-width: 100%;
      border-radius: 44px;
      background: transparent linear-gradient(180deg, #FFF7F500 0%, #FFF7F5 100%) 0% 0% no-repeat padding-box;
      @include mobile {
        flex-direction: column;
      }
      @media (max-width: 840px) {
        display: none;
      }
      a {
        right: 44px;
        bottom: 30px;
        position: absolute;
        text-decoration: underline;
        font: normal normal normal 16px/22px Sofia Pro !important;
        letter-spacing: 0px;
        color: #F87708;
      }
    }
  }
  @media (max-width: 1024px) {
    flex-direction: column;
    .onboarding-panel-2 {
      margin: 0 25px;
      //.track-title {
      //  font: normal normal bold 22px/23px Nunito Sans !important;
      //}
      h4 {
        font: normal normal normal 14px/19px Nunito Sans !important;
      }
    }
  }
}
.boxx {
  background: #FFFFFF 0% 0% no-repeat padding-box;
  display: flex;
  align-items: center;
  justify-content: space-between;
  border: 1px solid #D9D9D9;
  border-radius: 15px;
  max-width: 374px;
  max-height: 129px;
  padding: 0 2em;
  h4 {
    font: normal normal bold 20px/23px Sofia Pro;
    color: black;
  }
  p {
    font: normal normal normal 16px/24px Sofia Pro;
  }
  .last-box {
    input {
      flex: 1;
      height: 45px;
      background: #FFFFFF 0% 0% no-repeat padding-box;
      border: 1px solid #E2E2E2;
      border-radius: 23px 0px 0px 23px;
    }
    button {
      background: #FFFFFF 0% 0% no-repeat padding-box;
      border: 2px solid #F87708;
      border-radius: 0px 23px 23px 0px;
      width: 88px;
      height: 45px;
      font: normal normal normal 16px/22px Sofia Pro;
      letter-spacing: 0px;
      color: #F87708;
    }
  }
}
</style>
